import React from 'react'
import { SquareProps } from './props'
import styles from './styles.scss'

export const Square: React.FC<SquareProps> = (props) => {
    const { colour } = props

    return <span className={styles.square} style={{ background: colour }}/>
}
